export default function useGetConfirmPwdIsValid(pwd?: string, confirmPwd?: string) {
  if (pwd === undefined && confirmPwd === undefined) {
    return true
  } else if (pwd === undefined || confirmPwd === undefined) {
    return false
  }

  return pwd.localeCompare(confirmPwd) === 0
}
